import {ReactText} from 'react';
import {createAction} from '@reduxjs/toolkit';
import {VariantType} from 'notistack';

export const notify = createAction<{
    message: string;
    key: ReactText;
    variant: VariantType;
}>('notifier/notify');

export const clearNotification = createAction<ReactText>('notifier/clearNotification');
